import { dangerouslyGetFeatureGateSync } from '@trello/feature-gate-client';

import { routes, type RouteIdType } from './routes';

let isEnabled: boolean | undefined;

/**
 * Checks if the React Router feature gate is enabled.
 */
export const isReactRoutingEnabled = (): boolean => {
  if (isEnabled === undefined) {
    isEnabled = dangerouslyGetFeatureGateSync('tplat_react_router');
  }
  return isEnabled;
};

const routeGateCache: Partial<Record<RouteIdType, boolean>> = {};

/**
 * Checks if the feature gate for a specific route is enabled.
 */
export const isRouteModernized = (routeId: RouteIdType): boolean => {
  if (routeGateCache[routeId] === undefined) {
    const featureGate = routes[routeId]?.modernizationFeatureGate;
    routeGateCache[routeId] =
      !!featureGate && dangerouslyGetFeatureGateSync(featureGate);
  }
  return routeGateCache[routeId];
};
